import React from 'react'
import { useTranslation } from 'react-i18next'
import FormRow from '../../../components/FormRow'

interface CustomerCopilotStatusRowProps {
  copilotEnabled?: boolean
}

function CustomerCopilotStatusRow({ copilotEnabled }: Readonly<CustomerCopilotStatusRowProps>) {
  const { t } = useTranslation()
  const isOn = copilotEnabled === true

  return (
    <FormRow title={t('customers.copilotAccess')}>
      <div className="form-row-special-input">
        <span className="d-flex align-items-center" data-testid="copilot-access-status">
          <i
            className={`fal ${isOn ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'} fa-md me-2`}
            aria-hidden="true"
            data-testid={isOn ? 'copilot-access-on' : 'copilot-access-off'}
          />
          {isOn ? t('common.yes') : t('common.no')}
        </span>
      </div>
    </FormRow>
  )
}

export default CustomerCopilotStatusRow
